import styled, { css } from 'styled-components';
import {
  spacer8,
  spacer16,
  spacer24,
} from '@spotify-internal/encore-web/es/tokens';
import { StyledNavLink } from '../../LinkStyles';

export const StyledWrapper = styled.div`
  display: grid;
  grid-gap: ${spacer8};
  grid-template-columns: repeat(2, max-content);
  align-items: center;
`;

const navLinkBaseStyles = css`
  padding: ${spacer8} ${spacer16};
  border: 1px solid transparent;
  border-radius: ${spacer24};
`;

export const SignInNavLink = styled(StyledNavLink)`
  ${navLinkBaseStyles}
  &:focus,
  &:hover {
    border: 1px solid white;
  }
`;

export const SignUpNavLink = styled(StyledNavLink)`
  ${navLinkBaseStyles}
  color: #e8f524;

  &:focus,
  &:hover {
    color: #f4ff50;
    border: 1px solid #f4ff50;
  }
`;
